<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
  export default {
    name: 'App',
    metaInfo: {
      title: '',
      titleTemplate: '%s | Impôt AD',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { property: 'og:title', content: 'Impôt AD - Services comptables' },
        { property: 'og:url', content: 'https://www.impotad.com' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: 'Impôt AD est une entreprise spécialisée dans la production de déclarations de revenus des particuliers et services comptables connexes.' },
        { property: 'og:image', content: 'https://impotad.com/impot_ad_preview.jpg' },
      ],
    },
  }
</script>

<style lang="sass">
  .extra-padding
    padding-bottom: 96px !important
    padding-top: 96px !important

    @media screen and (max-width: 959px)
      padding-top: 48px !important
      padding-bottom: 48px !important
</style>
